
















import Vue from 'vue';
import ScrmHelp from 'common/components/ui/ScrmHelp/index.vue';
import userVuex from '../vuex/common';

export default Vue.extend({
  mixins: [userVuex],
  components: {
    ScrmHelp,
  },
  data() {
    return {
      imgUrl: '',
      upgradeReason: '试用结束了',
      reasonDesc: '您的试用已经到期，如需继续使用，请升级会员。',
    };
  },
  watch: {
    'accountState.isTrial'() {
      this.check();
    },
  },
  methods: {
    toUpgrade() {
      window.location.href = '#/upgrade/buy';
    },
    check() {
      if (this.accountState.crmLevel && this.accountState.isExpired) {
        this.imgUrl = require('assets/img/crown.svg');
        this.upgradeReason = '会员过期了';
        this.reasonDesc = '您的会员已经到期，如需继续使用，请升级会员。';
      } else if (this.accountState.crmLevel && !this.accountState.isExpired && this.accountState.crmLevel.followerLevel < this.accountState.fansLevel) {
        this.imgUrl = require('assets/img/lacking.svg');
        this.upgradeReason = '配额不足';
        this.reasonDesc = '您当前的配额已耗尽，请立即升级。';
      } else if (!this.accountState.crmLevel && !this.accountState.isTrial) {
        this.imgUrl = require('assets/img/balloon.svg');
      }
    },
  },
  mounted() {
    this.check();
  },
});
